import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import './TaskWidget.css';

class TaskWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasVoted: false,
    }
  }

  render() {
    const {
      description,
      location,
      name,
      upvotes,
    } = this.props.task;

    return (
      <div className="task-widget" onClick={this.props.onClick}>
        {name}
        <div className="task-widget--score">
          <span>{upvotes}</span>
          { this.props.enableUpvote && !this.state.hasVoted && (
            <Button onClick={() => this.setState({hasVoted: true})}>upvote</Button>
          )}
        </div>
      </div>
    );
  }
}

export default TaskWidget;



// WEBPACK FOOTER //
// ./src/TaskWidget.js